import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format, subWeeks } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { NavLink } from "react-router-dom";
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Select from 'react-select';
import {
  startOfWeek,
  endOfWeek,
  addWeeks,
  startOfYear,
  isAfter,
} from 'date-fns';

// Material UI Component
import {
        FormGroup,
        FormLabel,
        FormControl,
        // ListItemText,
        TextField,
        // Checkbox,
        // FormControlLabel,
        Grid,
        InputLabel,
        Input,
        // MenuItem,
        Modal,
        Backdrop,
        Fade,
        FormHelperText,
        NativeSelect,
        Button,
        Breadcrumbs,
        Typography,
} from "@material-ui/core";
import { makeStyles, createMuiTheme, MuiThemeProvider} from "@material-ui/core/styles";

// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
//cookies
import {get_cookies} from "../../../components/Cookies/Cookies";
import numeral from "numeral";

const useStyles = makeStyles((theme) => ({
        modal: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
        },
}));

function generatePastTuesdayToMondayWeeks(weeksCount = 52) {
  const today = new Date();
  const monday = startOfWeek(today, { weekStartsOn: 1 });
  let startDate = addDays(monday, 1); // This week's Tuesday

  const weeks = [];

  for (let i = 0; i < weeksCount; i++) {
    const start = subWeeks(startDate, i);
    const end = addDays(start, 6); // Monday

    weeks.push({
      label: `${format(start, 'MMM dd')} - ${format(end, 'MMM dd, yyyy')}`,
      value: {
        start: start.toISOString().slice(0, 10),
        end: end.toISOString().slice(0, 10),
      },
    });
  }

  return weeks;
}
      

const AccountUpgradeReport = () => {
        const [uniqueID, setUniqueId] = useState('');
        const [posts, setPosts] = useState([]);
        const [refViewData, setRefViewData] = useState([]);
        const [dataLoaded, setDataLoaded] = useState(false);
        const [open, setOpen] = useState(false);
        const [downloadFlag, setDownloadFlag] = useState(false);
        const [modalOpen, setModalOpen] = useState(false);
        const [dateRange, setDateRange] = useState({
                startDate: startOfWeek(new Date(), { weekStartsOn: 1 }),
                endDate: endOfWeek(new Date(), { weekStartsOn: 1 }),
        });
        const [weekOptions, setWeekOptions] = useState([]);
        const [selectedWeek, setSelectedWeek] = useState(null);
        const [disableBtn, setDisableBtn] = useState(true);

        const classes = useStyles();
        
        const [useridNo, setuseridNo] = useState(get_cookies('branchidno'));
        // console.log(uniqueID);
        // Data Fetching
        useEffect(() => {
                data();
        }, []);

        useEffect(() => {
              if(selectedWeek != null){
                setDisableBtn(false);
              }else{
                setDisableBtn(true);
              }
              }, [selectedWeek]);
            
              useEffect(() => {
                setDataLoaded(false);
                const generatedWeeks = generatePastTuesdayToMondayWeeks(52);
              
                const payload = generatedWeeks.map((w) => w.value);
              
                axios
                  .post(process.env.REACT_APP_API_URL+'get_accountupgrade_date', { weeks: payload,jc_user_id_no: useridNo, })
                  .then((res) => {
                 
                    setWeekOptions(
                      generatedWeeks.filter((week) =>
                        res.data.some(
                          (r) =>
                            r.start === week.value.start &&
                            r.end === week.value.end
                        )
                      )
                    );
                    setDataLoaded(true);
                  });
                  
              }, []);
            
        useEffect(() => {
                if(posts.length > 0){
                        setDownloadFlag(true);
                }else{
                        setDownloadFlag(false);
                }
        }, [posts]);
        //search button
        const dataFilter = async () => {

                console.log('weerk',selectedWeek.value);
        //         setDataLoaded(false);
        await axios.get(
                        process.env.REACT_APP_API_URL+'get_accountupgrade_report', {
            params:{
                date_from: selectedWeek.value.start, //format(dateRange.startDate, "yyyy/MM/dd/")
                date_to: selectedWeek.value.end,  //format(dateRange.endDate, "yyyy/MM/dd/")
                jc_user_id_no: useridNo,
                                unique_id: uniqueID
            }
        }).then((res)=>{
                console.log('reports',res.data)
                        setPosts(res.data.comencash);
                        // setRefViewData(res.data.comencash.ref_info);
                }).catch((error)=>{
                        // console.log(error.message);
                })
                setDataLoaded(true);
    }

        const data = async () => {
                setDataLoaded(true);
        };

        const toggle = () => setOpen(!open);

        const handleModalOpen = () => {
                setModalOpen(true);
        };

        const handleModalClose = () => {
                setModalOpen(false);
        };


        // const dateRangeHandler = (range) => {
        //         const start = startOfWeek(range.startDate, { weekStartsOn: 1 }); // Monday
        //         const end = endOfWeek(range.endDate, { weekStartsOn: 1 });       // Sunday
              
        //         setDateRange({ startDate: start, endDate: end });
        //         setOpen(false);
        //       };
        const columns = [
                {
                        name: "trandate",
                        label: "Encashment Date",
                        // options: {
                        //   customHeadRender: (columnMeta) => (
                        //     <th
                        //       key={columnMeta.index}
                        //       style={{ zIndex: 0, position: "relative" ,fontWeight:"400",textTransform:"none"  }} 
                        //     >
                        //       {columnMeta.label}
                        //     </th>
                        //   ),
                        // },
                      },
                      // {
                      //   name: "date_released",
                      //   label: "Date Released",
                      //   options: {
                      //     customHeadRender: (columnMeta) => (
                      //       <th
                      //         key={columnMeta.index}
                      //         style={{ zIndex: 0, position: "relative",fontWeight:"400",textTransform:"none"   }}
                      //       >
                      //         {columnMeta.label}
                      //       </th>
                      //     ),
                      //   },
                      // },
                {
                        name: "checkno",
                        label: "Check No",
                        // options: {
                        //         customHeadRender: (columnMeta) => (
                        //           <th
                        //             key={columnMeta.index}
                        //             style={{ zIndex: 0, position: "relative",fontWeight:"400",textTransform:"none"   }} 
                        //           >
                        //             {columnMeta.label}
                        //           </th>
                        //         ),
                        //       },
                },
                {
                        name: "curcode",
                        label: "Currency",
                },
                // {
                //         name: "atype",
                //         label: "Account type",

                // },
                // {
                //         name: "amount",
                //         label: "Amount(USD)",
                //               options: {
                //                 customHeadRender: (columnMeta) => {
                //                         return (
                //                           <th key={columnMeta.index} style={{ textAlign: "right", paddingRight: "16px" }}>
                //                             <div style={{ textAlign: "right", fontWeight:"400",textTransform:"none"  }}>Amount ({get_cookies('curcode')})</div>
                //                           </th>
                //                         );
                //                       },
                //                 customBodyRender: (value, tableMeta, updateValue) => {
                //                   return (
                //                     <div style={{ textAlign: "right" }}>
                //                       {numeral(value).format("0,0.00")}
                //                     </div>
     
                //                   );
                //                 },
                //                 setCellHeaderProps: () => ({
                //                         style: { alignItems: "flex-end", },
                //                       }),
                //                       setCellProps: () => ({
                //                         style: { textAlign: "right" },
                //                       }),
                                  
                //               },
                // },
                {
                        name: "totalamount",
                        label: "Amount",
                        options: {
                                customHeadRender: (columnMeta) => {
                                        return (
                                          <th key={columnMeta.index} style={{ textAlign: "right", paddingRight: "16px" }}>
                                            <div style={{ textAlign: "right",fontWeight:"400",textTransform:"none"  }}>Amount</div>
                                          </th>
                                        );
                                      },
                                customBodyRender: (value, tableMeta, updateValue) => {
                                  return (
                                    <div style={{ textAlign: "right" }}>
                                      {numeral(value).format("0,0.00")}
                                    </div>
     
                                  );
                                  
                                },
                                setCellHeaderProps: () => ({
                                        style: { justifyContent: "flex-end", display: "flex" },
                                      }),
                                      setCellProps: () => ({
                                        style: { textAlign: "right" },
                                      }),
                                  
                              },
                },


        //         {
        //                 name: "is_encashed",
        //                 label: "Status",
        //                 options: {
				// customBodyRenderLite: (dataIndex)=> {
				// 	let is_released =  posts[dataIndex].is_encashed;
				// 	if(is_released == 1){

				// 		return`Encashed`;
				// 	}else{
        //                                         return`Processing`;
				// 	}
				  

				//       }
			  //     }
        //         },
            {
                    name: "action",
                    label: "Action",
                    options: {
                            download: false, //exclude this column in csv export
                            sort:false,
                            filter: false,
                            customHeadRender: (columnMeta) => {
                                return (
                                  <th
                                    key={columnMeta.index}
                                    
                                  >
                                    <div
                                      style={{
                                        fontWeight: "400",
                                        textTransform: "none",
                                      }}
                                    >
                                      Action
                                    </div>
                                  </th>
                                );
                              },
                            customBodyRenderLite: (dataIndex) => {
  		let data =  posts[dataIndex].ref_info;
                                            return(
        
                                                                   <div style={{textAlign: "center"}}>
                                                                
                                                                            <NavLink
  to={{
    pathname: "/reports/account-upgrade-report-view",
 state: { refViewData: data }
  }}
 
>
                                                                                    <Button variant="contained" color="primary" style={{backgroundColor: "#4caf50", color:"#fff"}}>
                                                                                            View
                                                                                    </Button>
                                                                            </NavLink>
        
                                                                   </div>
        
                                            )
                                    }
                    },
            }

        ];

        const options = {
                filter: false,
                // filterType: "dropdown",
                selectableRows: "none",
                filterType: "multiselect",
                responsive: "standard",
                download: false,  //add this
                print: false, //add this
                viewColumns :false,
                setFilterChipProps: (colIndex, colName, data) => {
                        //console.log(colIndex, colName, data);
                        return {
                                color: "primary",
                                variant: "outlined",
                                className: "testClass123",
                        };
                },
                // customTableBodyFooterRender: () => {
                //         const total = posts.reduce((sum, row) => sum + parseFloat(row.amount_php || 0), 0);
                    
                //         return (
                //           <TableFooter>
                //             <TableRow >
                //               <TableCell colSpan={columns.length - 2} align="right" style={{ fontWeight: 'bold',color:"black" }}>
                //                 Total:
                //               </TableCell>
                //               <TableCell style={{ fontWeight: 'bold' ,color:"black",borderWidth:1,textAlign:'right'}}>
                //                 {numeral(total).format("0,0.00")}
                //               </TableCell>
                //               <TableCell style={{ fontWeight: 'bold' ,color:"black",borderWidth:1}}>
                               
                //               </TableCell>
                //             </TableRow>
                //           </TableFooter>
                //         );
                //       }

                // tableBodyHeight,
        };

    const style = {
                marginBottom: '1rem',
                marginTop:"2.5em",
        };

        return (
                <div className="page">
                        <div className="page-header">
                                <div className="page-icon">
                                        <ShoppingCartIcon />
                                </div>
                                <Breadcrumbs aria-label="breadcrumb">
                                        <NavLink to="/reports">
                                                <h2 className="header-title">Reports</h2>
                                        </NavLink>  
                                        <Typography color="textPrimary">Wholesale Set Payout Summary Report</Typography>
                                </Breadcrumbs>
                        </div>
                        <div className="page-container">


                                {!dataLoaded ? (
                                        <Preloader />
                                ) : (
                                        <>                                <div style={style}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                                        <Select
                                                        options={weekOptions}
                                                        value={selectedWeek}
                                                        onChange={setSelectedWeek}
                                                        placeholder="Select a week"
                                                        getOptionLabel={(option) => option.label}
                                                        menuPortalTarget={document.body}
                                                        isSearchable={false}
                                                        styles={{
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        control: (base) => ({
                                                        ...base,
                                                        width: 'auto',
                                                        paddingLeft: 8,
                                                        paddingRight: 8,
                                                        }),
                                                        }}
                                                        />
                
                                            </Grid>
                                            <Grid item xs={4} lg={1} xl={1}>
                                                <Button variant="contained" disabled={disableBtn}  color="primary"  onClick={() => {dataFilter()}}>Search</Button>
                                            </Grid>
                                        </Grid>        
                                    </div> <MUIDataTable
                                                        title={
                                                                <div>
                                                                        <h3 className="header-title" style ={{color: "#339933"}}>
                                                                        Wholesale Set  Payout Summary Report
                                                                        </h3>
                                                                </div>
                                                        }
                                                        data={posts}
                                                        columns={columns}
                                                        options={options}
                                                /></>
                                               
                                )}
                        </div>
                </div>
        );
};

export default AccountUpgradeReport;